import { ITopProductProps } from '../../../../topProduct.models';
import * as S from './topNavigationLiteCard.style';
import { energyManager } from '@vfit/consumer/providers';
import { Button, ImageAtoms, Price, Svg } from '@vfit/shared/atoms';
import ProductOptions from '../../../../../ProductCardLite/components/ProductOptions/productOptions';
import { IActionType, IGradientImage, PriceVariant } from '@vfit/shared/models';
import { DetailsChecklist } from '../DetailsChecklist/detailsChecklist';
import { useState } from 'react';
import { VfModal } from '@vfit/shared/components';
import { purify } from '@vfit/shared/themes';
import { checkIsApp, trackActionByActionType, usePage } from '@vfit/consumer/data-access';
import { openPopup } from '@vfit/shared/data-access';
import { useDeviceType } from '@vfit/shared/hooks';
import { TopNavigationLiteCardPopup } from './components/TopNavigationLiteCardPopup/topNavigationLiteCardPopup';
import { goBackFromUrl } from '../../../../topProduct.utils';

export const TopNavigationLiteCard = ({ product }: ITopProductProps) => {
  const { page } = usePage();
  const {
    title,
    price,
    priceLiteLabel,
    originalPrice,
    recurrence,
    description,
    descriptionPdp,
    image,
    imageTablet,
    imageMobile,
    backLabel,
    backUrl,
    inflactionPdp,
    priceVariant,
    pdpLiteOptionDetails,
    pdpLiteCtaPopup,
    pdpSecondAction,
    pdpLiteMarketingTagLabel: marketingTagLabel,
    pdpLiteMarketingTagColor: marketingTagColor,
    pdpLiteMarketingTagBackground: marketingTagBg,
    pdpLiteMarketingTagSecondaryLabel: secondaryMarketingTagLabel,
    pdpLiteMarketingTagSecondaryColor: secondaryMarketingTagColor,
    pdpLiteMarketingTagSecondaryBackground: secondaryMarketingTagBg,
    pdpLiteOfferClaimCard,
    pdpLiteOfferNameCard,
  } = product;
  const { isTablet } = useDeviceType();
  const [pDescription, pDescriptionPdp] = purify([description || '', descriptionPdp || '']);
  const [openModal, setIsOpenModal] = useState(false);

  const onActionProduct = () => {
    trackActionByActionType({
      type:pdpSecondAction?.type,
      title: pdpSecondAction?.title,
    });
    const action = pdpSecondAction;
    let autoActionUrlOverride;
    let finalAction;
    switch (pdpSecondAction?.type) {
      case IActionType.CUSTOM_URL:
        if (action?.url) {
          window.open(action.url, action?.isBlank === 'true' ? '_blank' : '_self');
        }
        break;
      case IActionType.CALL_ME_NOW:
        autoActionUrlOverride = (product?.ctcPdpUrl || action?.callMeNow) as string;
        finalAction = checkIsApp()
          ? autoActionUrlOverride
          : product?.ctcPdpUrl || action?.callMeNow;
        if (finalAction) openPopup(finalAction);
        break;
      case IActionType.CLICK_TO_CALL_ENERGY:
        document.dispatchEvent(
          new CustomEvent('energyCtcNotificationEvent', {
            detail: {
              product,
              action: action,
              taggingOption: page?.params?.elements?.taggingOptions,
            },
          })
        );
        break;
      case IActionType.ENERGY_FUNNEL:
        energyManager.handleEnergyManager({
          product,
          showModal: true,
        });
        break;
      default:
        break;
    }
  };

  return (
    <>
      <S.ExternalContainer>
        <S.Breadcrumb>
          <Svg name={'chevronLeft'} width={16} height={16} />
          <S.GoBackLabel
            onClick={() => {
              if (backUrl) window.location.href = backUrl || '';
              else goBackFromUrl();
            }}
          >
            {backLabel}
          </S.GoBackLabel>
        </S.Breadcrumb>
        <S.CardContainer>
          <S.TopLayout>
            <S.DivImgContainer>
              <ImageAtoms
                gradient={IGradientImage.GRADIENT_TOP_LEFT}
                nameCard="slideProduct"
                image={image}
                imageMobile={imageMobile}
              />
              <ImageAtoms
                nameCard="slideProductLite"
                image={isTablet ? imageTablet || image : image}
                imageMobile={imageMobile}
                style={{ borderRadius: '20px 20px 0 0' }}
              />
            </S.DivImgContainer>

            <S.TagContainer>
              {marketingTagLabel && (
                <S.Tag bgColor={marketingTagBg} color={marketingTagColor}>
                  <span>{marketingTagLabel}</span>
                </S.Tag>
              )}
              {secondaryMarketingTagLabel && (
                <S.Tag bgColor={secondaryMarketingTagBg} color={secondaryMarketingTagColor}>
                  <span>{secondaryMarketingTagLabel}</span>
                </S.Tag>
              )}
            </S.TagContainer>
            <S.TitleContainer>
              {pdpLiteOfferClaimCard ? (
                <S.Title
                  dangerouslySetInnerHTML={{
                    __html: pdpLiteOfferClaimCard || '',
                  }}
                />
              ) : (
                <S.Title>{title}</S.Title>
              )}
              {pdpLiteCtaPopup && (
                <S.SubtitleCta onClick={() => setIsOpenModal(true)}>
                  {pdpLiteCtaPopup}
                </S.SubtitleCta>
              )}
            </S.TitleContainer>
          </S.TopLayout>
          <S.OfferSection>
            <div>
              {pdpLiteOfferNameCard && (
                <S.offerNameCardTitle dangerouslySetInnerHTML={{ __html: pdpLiteOfferNameCard }} />
              )}
              <Price
                label={priceLiteLabel || ''}
                amount={price}
                oldAmount={originalPrice}
                recurrence={recurrence}
                variant={product?.isLandingClub ? 'freeAmount' : (priceVariant as PriceVariant)}
                detail={product?.isLandingClub ? product?.subprice : ''}
                description={product?.isLandingClub ? product?.descriptionRecurring : ''}
              />
              {(pDescriptionPdp || pDescription) && (
                <div
                  className="productDescription"
                  dangerouslySetInnerHTML={{ __html: pDescriptionPdp || pDescription || '' }}
                />
              )}
            </div>
            <ProductOptions inflactions={inflactionPdp} />
            {pdpSecondAction?.title && (
              <S.ActionContainer>
                <Button
                  onClick={onActionProduct}
                  variant={'secondary'}
                  name={`action_actsecond_${product?.offerId?.toString() || ''}`}
                >
                  {pdpSecondAction?.title}
                </Button>
              </S.ActionContainer>
            )}
          </S.OfferSection>
          <S.DetailSection>
            {pdpLiteOptionDetails && <DetailsChecklist checkList={pdpLiteOptionDetails} />}
          </S.DetailSection>
        </S.CardContainer>
      </S.ExternalContainer>
      <VfModal isOpen={openModal} handleClose={() => setIsOpenModal(false)}>
        <TopNavigationLiteCardPopup product={product} />
      </VfModal>
    </>
  );
};
